import React, { Fragment, useEffect, useRef, useState } from 'react'
import _ from 'lodash'
import classnames from 'classnames'
import { shallowEqual, useSelector } from 'react-redux'
import ContentPlain from '../../../../components/layout/ContentPlain'
import Button from '../../../../components/library/buttons/Button'
import '../../../../stylesheets/custom_scrollbar.scss'
import noteService from '../../services/notes/NoteService'
import Note from './Note'
import NotesTableSortHeader from './NotesTableSortHeader'
import './NotesWindow.scss'
import AddNoteModal from './AddNoteModal'
import { TaskStatus } from '../../../vdo-ticket/services/TaskStatus'
import HrbTranslate from '../../../../components/language/HrbTranslate'
import TaskErrorText from '../../../../components/library/workflow-tasks/TaskErrorText'

const NotesWindow = () => {

    const messageListRef = useRef()

    const [notes, setNotes] = useState(null)
    const [noNotes, setNoNotes] = useState(false)
    const [notesError, setNotesError] = useState(false)
    const [noteContent, setNoteContent] = useState('')
    const [sending, setSending] = useState(false)
    const [isReversed, setIsReversed] = useState(true)
    const [sortBy, setSortby] = useState('date')
    const [addNoteDialogOpen, setAddNoteDialogOpen] = useState(false)
    const [addNoteError, setAddNoteError] = useState(false)

    const { id: ticketId } = useSelector(state => state.tickets.selectedTicket || {}, shallowEqual)
    const language = useSelector(state => (state.layout.lang || 'EN').toUpperCase())

    const loadNotes = (loadNew) => {
        // get notes from the server
        noteService.getNotes(ticketId)
            .then(response => {
                if (response) {
                    if (notesError === true) {
                        setNotesError(false)
                    }
                    if (isReversed === true) {
                        response.sort((a, b) => (a.lastModified < b.lastModified) ? 1 : ((b.lastModified < a.lastModified) ? -1 : 0))
                    }
                    else {
                        response.sort((a, b) => (a.lastModified > b.lastModified) ? 1 : ((b.lastModified > a.lastModified) ? -1 : 0))
                    }
                    setNotes(response)

                    if (response !== null && response.length > 0) {
                        setNoNotes(false)
                    }
                    else {
                        setNoNotes(true)
                    }
                }
                else if (response === null) {
                    // An error has occurred
                    setNotesError(true)
                }
            })
            .catch(error => console.log(error))
    }
        
    const setSort = (newSortBy, reversed) => {
        if (newSortBy) {
            setSortby(newSortBy)
            setIsReversed(reversed)
            if (reversed === true) {
                notes.sort((a, b) => (a.lastModified < b.lastModified) ? 1 : ((b.lastModified < a.lastModified) ? -1 : 0))
            }
            else {
                notes.sort((a, b) => (a.lastModified > b.lastModified) ? 1 : ((b.lastModified > a.lastModified) ? -1 : 0))
            }
        }

        console.log('sorting')
    }   

    useEffect(() => {        
        loadNotes(true)            
    }, [])
        
    const showAddNoteDialog = () => {        
        setAddNoteDialogOpen(true)
    }

    const handleAddNote = async (messageText) => { 
        if (messageText) {
            setSending(true)
            // then perform the send
            let sentNote = await noteService.createNote(messageText.trim(), ticketId)
            if (sentNote) {
                setAddNoteDialogOpen(false);
                if (addNoteError === true) {
                    setAddNoteError(false)
                }
                // add sent message to our list and increase our offset value for the next getMessages call.
                let newNote = { messageText: messageText, lastModified: sentNote.lastModified, lastModifiedBy: sentNote.lastModifiedBy }
                let allNotes = notes.concat(newNote)
                setNotes(allNotes)
                setNoNotes(false)
                if (isReversed === true) {
                    allNotes.sort((a, b) => (a.lastModified < b.lastModified) ? 1 : ((b.lastModified < a.lastModified) ? -1 : 0))
                }
                else {
                    allNotes.sort((a, b) => (a.lastModified > b.lastModified) ? 1 : ((b.lastModified > a.lastModified) ? -1 : 0))
                }
                // clear the note textarea
                setNoteContent('')
                setSending(false)
            }
            else if (sentNote === null) {
                setAddNoteError(true)
                setAddNoteDialogOpen(true);
            }
        }
    }

    const handleHideModal = () => {
        setAddNoteDialogOpen(false);
        setAddNoteError(false);
    }

    return (
        <ContentPlain elementId='notes-pane' className='mt-6 mb-4'>
            <div className='columns pl-6 mb-0 notes-window-margin'>
                <div className='messaging-view card column is-10 py-5'>
                    <NotesTableSortHeader sort={sortBy} renderLinks={notes && notes.length > 0} isReversed={isReversed} onSortChanged={setSort} />
                    <div id='note-list' ref={messageListRef} key='note-container' className={classnames('notes-container notes-container-margin custom-scroll', { 'show-scroll': !notes })}>
                        {noNotes &&
                            <Fragment>
                            <div className='columns mt-6'>
                                <div className='column is-one-third'/>
                                <div className='column'>
                                    <HrbTranslate text='Notes.NoNotes' />
                                </div>
                                <div className='column is-one-third' />
                            </div>
                            </Fragment>
                        }
                        {notesError &&
                            <Fragment>
                                <div className='columns mt-6'>
                                    <div className='column is-one-fifth' />
                                    <div className='column'>
                                    <TaskErrorText errorKey="Notes.ErrorFailed" />
                                    </div>
                                    <div className='column is-one-fifth' />
                                </div>
                            </Fragment>
                        }
                        {!notes &&
                            <Fragment>
                                <Note />
                                <Note />
                                <Note />
                            </Fragment>
                        }
                        {notes && notes.map(note => {
                            return <Fragment key={note.id}>
                                <Note key={note.id} note={note} loaded />
                                <div key={'note-div' + note.id} className="prep-border smaller-margins centered-border"></div>
                            </Fragment>
                        })}
                    </div>
                </div>
            </div>
            <div className='add-note-button-container columns mt-4'>
            <Button elementId='btn-add-note'
                labelKey='Notes.AddNote'
                disabled={false}
                loading={false}
                buttonStyles='secondary is-offset-5'
                    onClick={() => showAddNoteDialog()} />
            </div>

            <AddNoteModal
                isOpen={addNoteDialogOpen} onCancel={handleHideModal} error={addNoteError}
                onAddNote={handleAddNote} ticketId={ticketId} status={addNoteError ? TaskStatus.ERROR : TaskStatus.IN_PROGRESS} />
        </ContentPlain>
    )
}

NotesWindow.whyDidYouRender = false

export default NotesWindow